import axios from "axios";
import {
  requestHandler,
  successHandler,
  errorHandler
} from "../interceptors";

export const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}admin_portal/v1`,
  withCredentials: true
});

// Handle request process
axiosInstance.interceptors.request.use((request) =>
  requestHandler(request)
);
// Handle response process
axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);
